
import jwtDecode from 'jwt-decode'
const SCRIPT_TAG_ID = 'f20860d6-6c9f-40a9-9b97-c60da00153be'
const SCRIPT_TAG_SRC =
  'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'

export default {
  mounted() {
    if (!document.querySelector(`#${SCRIPT_TAG_ID}`)) {
      const script = document.createElement('script')
      script.id = SCRIPT_TAG_ID
      script.src = SCRIPT_TAG_SRC
      script.type = 'text/javascript'

      script.onload = () => {
        window.AppleID.auth.init({
          clientId: this.$config.apple.clientId,
          scope: 'email name',
          redirectURI: this.$config.apple.redirectUri,
          state: new Date().getUTCMilliseconds().toString(),
          usePopup: true,
        })
      }

      document.body.appendChild(script)
    }
  },

  beforeDestroy() {
    const script = document.querySelector(`#${SCRIPT_TAG_ID}`)
    if (script) {
      document.body.removeChild(script)
    }
  },

  methods: {
    async handleClick() {
      try {
        const data = await window.AppleID.auth.signIn()
        const token = jwtDecode(data.authorization.id_token)

        if (!token?.sub) {
          throw new Error('No apple user identifier retrieved')
        }

        await this.$auth.loginWith('apiWithApple', {
          data: {
            apple_id: token.sub,
            // user sent only the first time
            apple_email: data.user?.email || token.email || undefined,
            first_name: data.user?.name?.firstName,
            last_name: data.user?.name?.lastName,
          },
        })
      } catch (error) {
        /**
         * According the documentation, the only error code that can be
         * returned by apple is `user_cancelled_authorize`.
         * According to my tests, the error `popup_closed_by_user` is returned when the user closes the popUp.
         */
        const handledErrors = [
          'user_cancelled_authorize', // the user refused the use of its Apple ID once authenticated
          'popup_closed_by_user', // the user closed the popup
          'user_trigger_new_signin_flow', // the user open a new popup while another is already open
        ]
        if (!handledErrors.includes(error.error)) {
          console.error(error)
          this.$notify({ type: 'error', message: 'phrase.error_unknown' })
        }
      }
    },
  },
}
